import styled from 'styled-components';

export const Item = styled.button`
  padding: 6px 16px;
  background: linear-gradient(180deg, #ffffff 2.56%, #f5f7f9 95.75%);
  border: 1px solid #cfd7df;
  font-weight: 600;
  font-size: 11px;
  color: #183247;
  cursor: pointer;
  &.selected {
    border-color: #bbdcfe;
    color: #f8fafb;
    background: #2c5cc5;
  }
  :last-child {
    border-radius: 0 4px 4px 0;
  }
  :first-child {
    border-radius: 4px 0 0 4px;
  }
`;

export const SwitchButtonContainer = styled.span`
  display: inline-block;
`;
